import { render, staticRenderFns } from "./Select.vue?vue&type=template&id=00822ec3&scoped=true"
import script from "./Select.vue?vue&type=script&lang=js"
export * from "./Select.vue?vue&type=script&lang=js"
import style0 from "./Select.vue?vue&type=style&index=0&id=00822ec3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00822ec3",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Select: require('/home/runner/work/platform/platform/packages/client/src/components/elements/form/select/Select.vue').default})
